import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GasActionButtonComponent } from './gas-action-button.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';

const COMPONENTS = [
  GasActionButtonComponent,
];

@NgModule({
  imports: [
    CommonModule,
    GasIconsModule,
  ],
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
})
export class GasActionButtonModule { }
